import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';

import {PageBodyWrapper} from '../styles';

import Loader from './../components/Loader';
import Spotlights from '../components/Spotlights';
import MoviesGrid from '../components/MoviesGrid';

import * as MoviesActions from '../store/actions/movie';

const Container = styled(PageBodyWrapper)`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-bottom: 40px;
    min-height: calc(100vh - 392px);

    & > div:only-child {
        margin-top: 30px;
    }
`;

const Movies = props => {
    const history = useHistory();
    const dispatch = useDispatch();

    props = {...props, ...useSelector(state => state.show)};

    const user = useSelector(state => state.user);
    const config = useSelector(state => state.config);
    const idp = user && user.idp;

    const [pageState, setPageState] = useState('loading');
    const [movies, setMovies] = useState(undefined);

    let {pickAndPlace} = config;

    if (!pickAndPlace) {
        pickAndPlace = {
            home: [{}],
            movie: [{}],
        };
    }

    if (!['prod', 'prd'].includes(process.env.REACT_APP_STAGE)) {
        if (localStorage.debug_picknplace) {
            try {
                pickAndPlace = JSON.parse(localStorage.debug_picknplace);
            } catch (error) {}
        }
    }

    useEffect(() => {
        window.turner_metadata.trackAction.push({
            type: 'pageview',
            data: {
                pageName: `cnplus.com/movies/`,
                section: 'Movies',
                subsection: 'nvs',
                contenttype: 'Movies',
                contenttitle: 'Movies',
                presentationtemplate: 'desktop',
                platform: 'web',
                domain: 'cnplus.com',
                region: 'latam',
                country:
                    user && user.countryIsoCode && user.countryName
                        ? `${user.countryIsoCode.toLowerCase()}|${
                              user.countryName
                          }`
                        : 'not loaded',
                brand: 'cartoon network',
                pageviewevent: 1,
                authstate:
                    user && user.jwtToken ? 'authenticated' : 'unauthenticated',
                mvpd: idp || 'idp not loaded',
            },
        });

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        handleLoadMovies();

        // eslint-disable-next-line
    }, [user.jwtToken]);

    useEffect(() => {
        if (movies !== undefined) {
            setPageState('ready');
        }

        //eslint-disable-next-line
    }, [movies]);

    const handleLoadMovies = async () => {
        let movies_response = await dispatch(MoviesActions.loadMovies());

        if (
            movies_response.status === 200 &&
            movies_response.data?.data?.movies
        ) {
            setMovies(movies_response.data.data.movies);
        } else {
            history.push('/error');
        }
    };

    const handleClickMovie = show_id => {
        history.push(`/play/${show_id}`);
    };

    let renderPage = React.useMemo(() => {
        if (pageState !== 'ready') {
            return <Loader margin="auto" />;
        } else {
            return (
                <>
                    {movies &&
                        movies.length > 0 &&
                        pickAndPlace &&
                        pickAndPlace.movie &&
                        pickAndPlace.movie.length > 0 && (
                            <Spotlights
                                pickAndPlace={pickAndPlace.movie}
                                movie_metadata={movies[0]}
                            />
                        )}

                    <MoviesGrid items={movies} onClickItem={handleClickMovie} />
                </>
            );
        }

        // eslint-disable-next-line
    }, [movies, pageState]);

    return <Container>{renderPage}</Container>;
};

export default Movies;
